import { fetchConfiguredTemplates } from '../api/dataInputApi';
import { Asset } from '../types/dataInputTypes';
import { useAutocompleteData } from './useAutocompleteData';

export const useTemplateSelector = (selectedAsset: Asset) => {
    return useAutocompleteData(`configuredTemplates ${selectedAsset?.assetId}`, (query) => fetchConfiguredTemplates(query, selectedAsset?.assetId), !!selectedAsset?.assetId);
};